import React from 'react';

const LowCredits = props => {
	return (
		<div {...props}>
			<svg width="100%" viewBox="0 0 432 432">
				<g>
					<title>{'Layer 1'}</title>
					<path
						fill="#5EAD46"
						d="M75.882 257.247c-34.842 40.746-32.203 95.51 4.655 81.154 21.7-8.452 49.81-65.873 56.113-97.316 6.304-31.444-25.927-24.578-60.768 16.162z"
					/>
					<path
						fill="#51943B"
						d="M98.445 322.953c17.049-21.388 33.557-58.68 38.206-81.867 4.146-20.688-8.388-24.788-27.37-13.573 2.199 13.9 6.545 44.57 4.108 56.02-2.135 10.03-9.977 28.36-14.944 39.42z"
					/>
					<path
						fill="#5EAD46"
						d="M363.286 257.247c34.842 40.746 32.203 95.51-4.655 81.154-21.701-8.452-49.811-65.873-56.113-97.316-6.305-31.444 25.926-24.578 60.768 16.162z"
					/>
					<path
						fill="#51943B"
						d="M340.722 322.953c-17.05-21.388-33.556-58.68-38.204-81.867-4.147-20.688 8.386-24.788 27.368-13.573-2.198 13.9-6.545 44.57-4.108 56.02 2.136 10.03 9.977 28.36 14.944 39.42z"
					/>
					<path
						opacity={0.32}
						fill="#3E3E3E"
						d="M362.866 400.684c0-13.746-65.612-24.887-146.548-24.887-80.935 0-146.547 11.142-146.547 24.887 0 4.503 7.079 8.723 19.397 12.366-3.976 3.022 62.812 15.53 145.215 12.325s128.483-11.985 128.483-24.69z"
					/>
					<path
						fill="#5EAD46"
						d="M288.046 399.11c-38.251-9.273-93.693-9.852-133.452 2.036-15.122 5.187-64.93 16.06-59.89-30.445 14.686-76.156 23.64-148.642 19.243-212.582 0-15.119 12.369-27.489 27.489-27.489l153.939-17.41c15.119 0 27.49 12.37 27.49 27.488-5.298 67.482 6.28 147.01 21.99 229.992 6.874 44.442-39.584 32.904-56.81 28.41z"
					/>
					<path
						fill="#51943B"
						d="M125.993 148.803c10.404-11.758 61.117-17.25 71.108-21.424 1.653-.692 3.437-1.982 5.26-3.64l-60.925 6.891c-15.12 0-27.49 12.37-27.49 27.49.952 13.82 1.276 28.041 1.056 42.612 2.228-22.229 5.765-46.024 10.99-51.929z"
					/>
					<ellipse
						transform="rotate(-67.728 201.384 204.96)"
						ry={8.47}
						rx={11.144}
						opacity={0.15}
						fill="#0D6C3F"
						cy={154.544}
						cx={226.301}
					/>
					<ellipse
						transform="rotate(-67.741 240.602 215.76)"
						ry={6.309}
						rx={8.304}
						opacity={0.15}
						fill="#0D6C3F"
						cy={165.355}
						cx={265.528}
					/>
					<ellipse
						transform="rotate(-65.821 289.213 195.592)"
						ry={9.301}
						rx={10.842}
						opacity={0.15}
						fill="#0D6C3F"
						cy={144.383}
						cx={312.442}
					/>
					<circle r={9.361} opacity={0.15} fill="#0D6C3F" cy={153.428} cx={285.634} />
					<path
						fill="#3F2945"
						d="M287.887 181.196a5.203 5.203 0 01-4.185-1.068c-.632-.512-15.047-11.77-32.19-1.943-2.467 1.423-5.61.56-7.026-1.904a5.141 5.141 0 011.899-7.028c23.413-13.432 43.006 2.202 43.827 2.873 2.202 1.818 2.524 5.064.727 7.261a5.176 5.176 0 01-3.052 1.81zM182.84 181.196a5.203 5.203 0 01-4.185-1.068c-.632-.512-15.047-11.77-32.19-1.943-2.467 1.423-5.61.56-7.026-1.904a5.141 5.141 0 011.899-7.028c23.413-13.432 43.006 2.202 43.828 2.873 2.202 1.818 2.524 5.064.727 7.261a5.178 5.178 0 01-3.053 1.81z"
					/>
					<ellipse ry={61.152} rx={61.16} fill="#FFF" cy={249.554} cx={272.213} />
					<ellipse ry={61.152} rx={61.16} fill="#FFF" cy={249.554} cx={167.91} />
					<path
						fill="#7f7f7f"
						d="M324.68 14.108C324.12 3.99 280.097-1.387 210.42 2.465l-.087.005c-69.685 3.85-112.85 14.05-112.29 24.164.56 10.125 12.603 28.651 17.527 117.724l204.666-11.314c-4.925-89.07 5.005-108.813 4.446-118.936z"
					/>
					<path
						fill="#191919"
						d="M319.152 107.551c-7.042-.73-48.077-4.586-103.25-1.536-54.27 3.001-94.195 11.13-102.065 12.821a997.528 997.528 0 011.73 25.522l204.667-11.314a961.422 961.422 0 01-1.082-25.493z"
					/>
					<path
						fill="#7f7f7f"
						d="M331.03 107.856c-4.403.243-15.32 12.411-26.927 14.372 0 0-63.876 5.281-86.791 6.548-22.921 1.27-86.902 3.053-86.902 3.053-11.737-.67-23.937-11.562-28.348-11.317-17.522.966 12.799 39.13 12.799 39.13l207.77-11.485c0 .001 25.92-41.27 8.399-40.3z"
					/>
					<path
						fill="#FEBC11"
						d="M41.164 138.471a5.595 5.595 0 010 11.188H7.596a5.595 5.595 0 01-5.594-5.594 5.597 5.597 0 015.594-5.594h33.568zM62.129 211.798a5.601 5.601 0 017.919 0 5.592 5.592 0 01-.008 7.911l-23.733 23.733a5.591 5.591 0 01-7.911 0 5.582 5.582 0 010-7.903l23.733-23.74zM49.14 178.843c2.937-.96 6.106.627 7.075 3.568.96 2.93-.65 6.091-3.585 7.067l-31.885 10.46a5.598 5.598 0 01-7.066-3.562 5.61 5.61 0 013.57-7.073l31.892-10.46zM62.129 76.333a5.601 5.601 0 007.919 0c2.185-2.183 2.178-5.725-.008-7.91L46.307 44.696a5.577 5.577 0 00-7.911 0 5.582 5.582 0 000 7.903l23.733 23.733zM49.14 109.29a5.607 5.607 0 007.075-3.57c.96-2.928-.65-6.09-3.585-7.067L20.745 88.201a5.592 5.592 0 00-7.066 3.562 5.603 5.603 0 003.57 7.065L49.14 109.29zM384.153 144.065a5.595 5.595 0 010-11.188h33.569a5.595 5.595 0 015.594 5.594 5.597 5.597 0 01-5.594 5.594h-33.57zM363.188 70.738a5.601 5.601 0 01-7.92 0 5.592 5.592 0 01.009-7.91l23.733-23.734a5.591 5.591 0 017.91 0 5.582 5.582 0 010 7.903l-23.732 23.741zM376.177 103.693c-2.936.961-6.105-.627-7.074-3.568-.961-2.93.649-6.09 3.585-7.067l31.885-10.46a5.598 5.598 0 017.066 3.562 5.61 5.61 0 01-3.57 7.072l-31.892 10.461zM363.188 206.204a5.601 5.601 0 00-7.92 0c-2.184 2.183-2.177 5.725.009 7.911l23.733 23.725a5.577 5.577 0 007.91 0 5.582 5.582 0 000-7.903l-23.732-23.733zM376.177 173.246a5.607 5.607 0 00-7.074 3.57c-.961 2.928.649 6.091 3.585 7.067l31.885 10.452a5.592 5.592 0 007.066-3.562 5.603 5.603 0 00-3.57-7.065l-31.892-10.462zM150.3 227.821c0 23.32 25.074 24.138 25.074 40.931 0 5.842-2.571 7.93-6.643 7.93-4.083 0-6.656-2.088-6.656-7.93v-6.414h-12.121v5.6c0 11.076 4.66 18.201 13.876 20.063v5.944h10.499v-5.944c9.094-1.862 13.876-8.987 13.876-20.063 0-23.32-25.073-24.135-25.073-40.93 0-5.828 2.332-8.05 6.416-8.05 4.072 0 6.416 2.223 6.416 8.05v3.373h12.12v-2.559c0-11.074-4.661-18.079-13.755-19.943v-6.064h-10.5v6.064c-8.973 1.984-13.528 8.991-13.528 19.942zM253.432 227.821c0 23.32 25.073 24.138 25.073 40.931 0 5.842-2.571 7.93-6.643 7.93-4.083 0-6.656-2.088-6.656-7.93v-6.414h-12.121v5.6c0 11.076 4.66 18.201 13.876 20.063v5.944h10.499v-5.944c9.094-1.862 13.876-8.987 13.876-20.063 0-23.32-25.073-24.135-25.073-40.93 0-5.828 2.332-8.05 6.416-8.05 4.072 0 6.416 2.223 6.416 8.05v3.373h12.12v-2.559c0-11.074-4.661-18.079-13.755-19.943v-6.064h-10.5v6.064c-8.973 1.984-13.528 8.991-13.528 19.942z"
					/>
					<path
						fillRule="evenodd"
						fill="#8F3D7C"
						d="M360.813 326.952c-20.334 11.486-24.52 21.8-26.38 39.16-1.828 17.065-9.454 48.54 17.659 48.54H398.5c18.26-1.03 19.555-15.089 15.906-42.76-1.331-10.092-.878-17.927-5.16-25.15-3.868-6.528-11.875-12.558-23.791-19.304l-2.588-.05c.484-11.186 8.149-15.065 11.767-25.316 3.21-6.17.294-9.279-3.762-9.747-7.074-.818-7.724 5.137-11.211 2.62-1.726-1.249-3.306-2.028-4.755-2.365-2.808-.656-5.124.34-7.048 2.784-2.451 3.108-1.561.256-6.017-1.987-18.3-9.222-6.382 14.6-4.26 20.11 1.777 4.61 3.18 9.138 3.739 13.477l-.507-.012z"
						clipRule="evenodd"
					/>
					<path
						fillRule="evenodd"
						fill="#3F2945"
						d="M360.194 322.123h25.38c1.597 0 2.9 1.306 2.9 2.9a2.91 2.91 0 01-2.9 2.901h-25.38a2.907 2.907 0 01-2.898-2.902 2.906 2.906 0 012.898-2.899z"
						clipRule="evenodd"
					/>
					<path
						fill="#FFF"
						d="M364.723 359.69c0 14.075 15.13 14.566 15.13 24.702 0 3.526-1.55 4.785-4.008 4.785-2.463 0-4.016-1.259-4.016-4.785v-3.873h-7.315v3.38c0 6.686 2.813 10.985 8.375 12.111v3.586h6.336v-3.586c5.489-1.126 8.375-5.425 8.375-12.11 0-14.076-15.131-14.567-15.131-24.703 0-3.515 1.406-4.858 3.87-4.858 2.46 0 3.874 1.342 3.874 4.858v2.037h7.314v-1.544c0-6.683-2.813-10.912-8.301-12.035v-3.662h-6.336v3.662c-5.417 1.196-8.167 5.425-8.167 12.035z"
					/>
					<path
						fillRule="evenodd"
						fill="#094E2A"
						clipRule="evenodd"
						d="M298.214 337.981h47.973v73.881h-47.973v-73.88z"
					/>
					<path
						fillRule="evenodd"
						fill="#1A8140"
						d="M346.187 359.946v2.96h-47.974v-2.96h47.974zm0 5.137v2.96h-47.974v-2.96h47.974zm0 5.14v2.96h-47.974v-2.96h47.974zm0 5.14v2.96h-47.974v-2.96h47.974z"
						clipRule="evenodd"
					/>
					<path
						fillRule="evenodd"
						fill="#0E6836"
						d="M303.997 340.556h36.408a3.942 3.942 0 002.73 4.051v9.24a3.942 3.942 0 00-2.73 4.053h-36.408a3.943 3.943 0 00-2.731-4.053v-9.24a3.943 3.943 0 002.73-4.05z"
						clipRule="evenodd"
					/>
					<path
						fillRule="evenodd"
						fill="#1D8140"
						clipRule="evenodd"
						d="M339.958 359.946v-6.232h6.229l-6.23 6.232z"
					/>
					<path
						fillRule="evenodd"
						fill="#FFF"
						d="M322.2 342.8a6.428 6.428 0 110 12.857 6.429 6.429 0 110-12.857z"
						clipRule="evenodd"
					/>
					<path
						fillRule="evenodd"
						fill="#1A8140"
						d="M346.187 380.795v2.96h-47.974v-2.96h47.974zm0 5.137v2.96h-47.974v-2.96h47.974zm0 5.14v2.96h-47.974v-2.96h47.974zm0 5.14v2.96h-47.974v-2.96h47.974zM346.187 401.45v2.961h-47.974v-2.962h47.974zm0 5.141v2.96h-47.974v-2.96h47.974zm0 5.138v2.962h-47.974v-2.962h47.974z"
						clipRule="evenodd"
					/>
					<path
						fillRule="evenodd"
						fill="#094E2A"
						clipRule="evenodd"
						d="M265.899 378.317h46.563v41.573h-46.563v-41.573z"
					/>
					<path
						fillRule="evenodd"
						fill="#1A8140"
						d="M312.462 399.634v2.87h-46.563v-2.87h46.563zm0 4.985v2.876h-46.563v-2.876h46.563zm0 4.991v2.87h-46.563v-2.87h46.563zm0 4.99v2.872h-46.563V414.6h46.563z"
						clipRule="evenodd"
					/>
					<path
						fillRule="evenodd"
						fill="#0E6836"
						d="M271.51 380.813h35.34a3.822 3.822 0 002.65 3.931v8.971a3.824 3.824 0 00-2.65 3.93h-35.34a3.824 3.824 0 00-2.65-3.93v-8.97a3.821 3.821 0 002.65-3.932z"
						clipRule="evenodd"
					/>
					<path
						fillRule="evenodd"
						fill="#1D8140"
						clipRule="evenodd"
						d="M306.415 399.634v-6.052h6.047l-6.047 6.052z"
					/>
					<path
						fillRule="evenodd"
						fill="#FFF"
						d="M289.18 382.992a6.242 6.242 0 016.24 6.24 6.24 6.24 0 01-12.48 0 6.24 6.24 0 016.24-6.24z"
						clipRule="evenodd"
					/>
					<path opacity={0.2} fill="#010101" d="M274.11 333.397c-36.272 22.774-79.14 26.433-116.353 5.775" />
				</g>
			</svg>
		</div>
	);
};

export default LowCredits;
